module.exports = __webpack_public_path__ + "img/9788954438261.4b9007ce.jpg";